/**
 * Icon Component
 *
 * Main entry point for the icon system that renders the appropriate icon type (solid/outline/phosphor).
 *
 * For detailed documentation, usage examples, and optimization guidelines,
 * please refer to the README.md file in this directory.
 */

import type { IconBaseProps } from './base'
import type { PhosphorWeight } from './types'

import { OutlineIcon } from './outline'
import { PhosphorIcon } from './phosphor'
import { SolidIcon } from './solid'

export { IconName, PhosphorIconName } from './types'

export interface IconProps extends IconBaseProps {
  outline?: boolean
  isPhosphor?: boolean
  weight?: PhosphorWeight // Only used when isPhosphor=true
}

/**
 * @deprecated Use `Icon` from `@moment/design-system-ui/icon` instead.
 */
// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function Icon({
  outline = false,
  isPhosphor = false,
  ...props
}: IconProps) {
  if (isPhosphor) {
    return <PhosphorIcon {...props} />
  }
  return outline ? <OutlineIcon {...props} /> : <SolidIcon {...props} />
}
